/**
 * Accent-insensitive, case-insensitive normalization.
 * Mirrors MariaDB utf8mb4_uca1400_ai_ci behavior used in backend search.
 */
export function normalizeForSearch(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
}

/**
 * Returns true if every whitespace-separated token in `term` appears
 * somewhere in `text` (after normalization). Order-independent.
 *
 * "garcia ana" matches "Ana García López" — each token checked independently.
 */
export function matchesSearch(text: string, term: string): boolean {
  if (!term.trim()) return true
  const normalized = normalizeForSearch(text)
  const tokens = normalizeForSearch(term).split(/\s+/).filter(Boolean)
  return tokens.every(token => normalized.includes(token))
}
